import { Fragment, useEffect, useState } from 'react'

import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Transition } from '@headlessui/react'
import { clsx } from 'clsx'
import { IconChevronDown, IconChevronUp, IconSearch } from 'packages/component-library/dist'

import { SelectItem } from '~/portal/types/ui.components'

interface SelectProductDesktopProps {
    defaultValue: SelectItem,
    options: (SelectItem)[],
    accentColor?: string,
    name?: string,
    placeholder?: string,
    onChange?: (option: SelectItem) => void,
    onOpenChange?: (open: boolean) => void,
  }

export const SelectProductDesktop = ({ 
  defaultValue,
  options,
  name = '',
  placeholder = '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- kept for backward-compatible prop signature; outline color is now driven solely by --sp-color-accent
  accentColor = '',
  onChange: onChangeProps,
  onOpenChange,
}: SelectProductDesktopProps) => {
  const [value, setValue] = useState<SelectItem>(defaultValue)
  
  const onChange = (option: SelectItem) => {
    setValue(option)
    onChangeProps?.(option)
  }

  return (
    <Listbox
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      name={name}
    >
      {({ open }) => {
        useEffect(() => {
          onOpenChange?.(open)
        }, [open])
        return (
          <div>
            <ListboxButton
              className={clsx(
                'flex items-center w-41 cursor-pointer rounded-l text-left bg-transparent',
                'h-10 text-body2 pl-3 py-2 border-r border-(--sp-color-border-subtle)',
                open && 'outline',
                'outline-(--sp-color-accent)',
                'justify-between'
              )}
            >
              <span className="mr-2 text-(--sp-color-text)"><IconSearch width={16} height={16} /></span>
              <span className="truncate text-(--sp-color-text)">{value?.name || placeholder}</span>
              <span className="pr-4 ml-auto text-(--sp-color-text-muted)">{open ? <IconChevronUp width={16} height={16} /> : <IconChevronDown width={16} height={16} />}</span>
            </ListboxButton>
        
            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="absolute flex flex-col shadow-[0_3px_6px_0_rgba(0,0,0,0.18)] rounded z-50 mt-1">
                <ListboxOptions className="sp-search-modal-dropdown ml-[-0.063rem] max-h-60 w-162 focus:outline-none z-50 overflow-y-auto overflow-x-hidden rounded bg-(--sp-color-surface-raised)">
                  {options.map((option: SelectItem) => (
                    <ListboxOption
                      key={option.id}
                      className={
                        clsx(
                          'hover:text-(--sp-color-text)',
                          (value?.id === option.id
                            ? 'text-(--sp-color-text)'
                            : 'text-(--sp-color-text-muted)'),

                          'hover:bg-(--sp-color-surface-hover)',
                          (value?.id === option.id
                            ? ('bg-(--sp-color-accent-subtle)')
                            : 'bg-(--sp-color-surface-raised)'),
                          'cursor-pointer select-none py-1.5 px-4 text-body2 wrap-break-word',
                        )
                      }
                      value={option}
                    >
                      {option.name}
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              </div>
            </Transition>
          </div>
        ) 
      }}
    </Listbox>
  )
}